import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { HorizontalLayout } from 'widgets/Layout';

import { FormElement, FormLabel, InputDescription } from './FormCommons';

interface FormToggleProps {
    name: string;
    label: string;
    disabled?: boolean;
    hideLabel?: boolean;
    description?: string;
    isNegative?: boolean;
}
export const FormToggle = ({
    name,
    label,
    disabled = false,
    description,
    hideLabel = false,
    isNegative = false,
}: FormToggleProps) => {
    const { register } = useFormContext();

    return (
        <HorizontalLayout $rowCenter $gap={16}>
            <Label>
                {hideLabel ? (
                    <div>
                        <Input type="checkbox" {...register(name)} disabled={disabled} $isNegative={isNegative} />
                        <Switch />
                    </div>
                ) : (
                    <FormElement>
                        <FormLabel as="span">{label}</FormLabel>
                        <Input type="checkbox" {...register(name)} disabled={disabled} $isNegative={isNegative} />
                        <Switch />
                    </FormElement>
                )}
            </Label>
            <InputDescription description={description} />
        </HorizontalLayout>
    );
};

const Label = styled.label`
    width: fit-content;
`;

const Switch = styled.div`
    position: relative;
    width: 50px;
    height: 28px;
    background: ${({ theme }) => theme.colors.cocoa300};
    border-radius: 28px;
    padding: 4px;
    transition: 300ms all;
    cursor: pointer;

    &:before {
        transition: 300ms all;
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 100%;
        top: 50%;
        left: 4px;
        background: white;
        transform: translate(0, -50%);
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const Input = styled.input<{ $isNegative: boolean }>`
    opacity: 0;
    position: absolute;

    &:checked + ${Switch} {
        background: ${({ theme, $isNegative }) => ($isNegative ? theme.colors.red500 : theme.colors.cocoa900)};

        &:before {
            transform: translate(22px, -50%);
            content: '✔';
        }
    }

    &:disabled ~ ${Switch} {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;
